import React, { Component, useState } from 'react'
import CompleteOrderForm from '../../Components/CompleteOrderForm/CompleteOrderForm'

import "./AdminOrder.css"
import DetailOrder from '../../Components/DetailOrder/DetailOrder'
import { Flex, Form } from 'antd'
import AdminOrderListTable from '../../Components/TableList/AdminOrderListTable'
import Title from 'antd/es/typography/Title'
import Text from 'antd/es/typography/Text'
import {  Radio } from 'antd';


const AdminOrder = ()=> {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [status, setStatus] = React.useState<string>("");

    return (
      <div className='AdminOrder-layout'>
        <div className='AdminOrder-header'>
            <div className='AdminOrder-Title'>
                <Title level={2} style={{marginTop:"0", display:"inline-block", width: 'fit-content'}} >Administracion de ordenes</Title>
                <Text type='secondary'></Text>
            </div>

            <Radio.Group disabled={loading} defaultValue="" value={status} onChange={(e)=>{setStatus(e.target.value)}} buttonStyle="solid">
                <Radio.Button value="">Todas</Radio.Button>
                <Radio.Button value="processing">Por Preparar</Radio.Button>
                <Radio.Button value="in progress">En Proceso</Radio.Button>
                <Radio.Button value="completed">Completada</Radio.Button>
                <Radio.Button value="canceled">Cancelada</Radio.Button>
            
            </Radio.Group>
        </div>
        <AdminOrderListTable
        loading={loading}
        setLoading={setLoading}
        status={status} />

      </div>
    )
}

export default AdminOrder